export default function formatPhoneNumber(input) {
  const digits = input.replace(/\D/g, '');

  if (input.trim().startsWith('+')) {
    return `tel:${digits}`;
  }

  if (digits.startsWith('0')) {
    return `tel:+380${digits.slice(1)}`;
  }

  return `tel:+${digits}`;
}